import { Component } from '@angular/core';
import { ConnectionService } from '../../services/connection-service';

@Component({
    selector: 'user-instructions-llm',
    templateUrl: './user-instructions-llm.html',
    standalone: false
})
export class UserInstructionsLLMComponent {
  userInstructions: any;
  userId: string = '';

  constructor(
    private conn: ConnectionService) {
  }

  async getInstructions(): Promise<void> {
    if (!this.userId) {
      alert('Please enter a user ID');
      return;
    }

    const response = await this.conn.getUserInstructionsFormatted(this.userId);
    this.userInstructions = response.data.userInstructions;
  }
}
